export function uuid(): string {
  const c = globalThis.crypto as Crypto | undefined;
  if (c?.randomUUID) return c.randomUUID();
  // RFC4122-ish fallback.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
    const r = (Math.random() * 16) | 0;
    const v = ch === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function now(): number {
  return typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
}

export function hostOf(url: string): string {
  try {
    return new URL(url, location?.href ?? 'http://localhost').host;
  } catch {
    return '';
  }
}

export function pathOf(url: string): string {
  try {
    return new URL(url, location?.href ?? 'http://localhost').pathname;
  } catch {
    return url;
  }
}

/** Suffix/exact host match against an allow/block list. "supabase.co" matches "x.supabase.co". */
export function domainMatches(host: string, patterns: string[]): boolean {
  host = host.toLowerCase();
  return patterns.some((p) => {
    p = p.toLowerCase().replace(/^\*\./, '');
    return host === p || host.endsWith(`.${p}`) || host.endsWith(p);
  });
}

export function isSameOrigin(url: string): boolean {
  try {
    return new URL(url, location.href).origin === location.origin;
  } catch {
    return true;
  }
}

export function matchesIgnore(url: string, patterns: (string | RegExp)[]): boolean {
  return patterns.some((p) => (typeof p === 'string' ? url.includes(p) : p.test(url)));
}

export function safeParseHeaders(h: HeadersInit | Headers | undefined | null): Record<string, string> {
  const out: Record<string, string> = {};
  if (!h) return out;
  if (h instanceof Headers) {
    h.forEach((v, k) => (out[k] = v));
  } else if (Array.isArray(h)) {
    for (const [k, v] of h) out[String(k)] = String(v);
  } else {
    for (const [k, v] of Object.entries(h)) out[k] = String(v);
  }
  return out;
}
